/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Language_Code_LabelInputs */

const en_image_export_language_code_label = /** @type {(inputs: Image_Export_Language_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Language Code`)
};

const fr_image_export_language_code_label = /** @type {(inputs: Image_Export_Language_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code langue`)
};

const de_image_export_language_code_label = /** @type {(inputs: Image_Export_Language_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprachcode`)
};

const it_image_export_language_code_label = /** @type {(inputs: Image_Export_Language_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice della lingua`)
};

const ru_image_export_language_code_label = /** @type {(inputs: Image_Export_Language_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Языковой код`)
};

const es_image_export_language_code_label = /** @type {(inputs: Image_Export_Language_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de idioma`)
};

const zh_cn2_image_export_language_code_label = /** @type {(inputs: Image_Export_Language_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语言代码`)
};

const ja_image_export_language_code_label = /** @type {(inputs: Image_Export_Language_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`言語コード`)
};

const hi_image_export_language_code_label = /** @type {(inputs: Image_Export_Language_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भाषा कोड`)
};

const pt_pt2_image_export_language_code_label = /** @type {(inputs: Image_Export_Language_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de idioma`)
};

/**
* | output |
* | --- |
* | "Language Code" |
*
* @param {Image_Export_Language_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_language_code_label = /** @type {((inputs?: Image_Export_Language_Code_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Language_Code_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_language_code_label(inputs)
	if (locale === "de") return de_image_export_language_code_label(inputs)
	if (locale === "it") return it_image_export_language_code_label(inputs)
	if (locale === "ru") return ru_image_export_language_code_label(inputs)
	if (locale === "es") return es_image_export_language_code_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_language_code_label(inputs)
	if (locale === "ja") return ja_image_export_language_code_label(inputs)
	if (locale === "hi") return hi_image_export_language_code_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_language_code_label(inputs)
	return en_image_export_language_code_label(inputs)
});